import type { TFunction } from 'i18next';
import { MenuProps } from 'antd';

const accountDetailItems = (t: TFunction): MenuProps['items'] => {
    return [
        {
            key: '/profile',
            label: t('menu.profile'),
        },
        { type: 'divider' },
    ];
};
export default accountDetailItems;
